import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';

/**
 * Generated class for the StockAbcPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-stock-abc',
  templateUrl: 'stock-abc.html',
})
export class StockAbcPage {

  chartData: any;
  chartLabels: any;
  chartCheck: any;
  //datatable
  rows_a = [];
  temp_a = [];
  columns_a = [
    { prop: 'name', name: this.translate.instant('general-nombre') },
    { prop: 'total', name: this.translate.instant('general-total') }
  ];


  rows_b = [];
  temp_b = [];
  columns_b = [
    { prop: 'name', name: this.translate.instant('general-nombre') },
    { prop: 'total', name: this.translate.instant('general-total') }
  ];

  rows_c = [];
  temp_c = [];
  columns_c = [
    { prop: 'name', name: this.translate.instant('general-nombre') },
    { prop: 'total', name: this.translate.instant('general-total') }
  ];


  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;



  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController) {
    this.checkDateBeforeGet();
  }


  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.checkDateBeforeGet();
      }
    });
    profileModal.present();
  }

  checkDateBeforeGet() {
    if (this.advancedAnalyticsServices.date2 >= moment().format('YYYY-MM-DDTHH:mm:ss')) {
      this.advancedAnalyticsServices.date2 = moment().subtract(1, 'day').endOf('day').format('YYYY-MM-DDTHH:mm:ss');
      //msg
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-fecha-final-no-anterior-fecha-actual'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
    this.getAnalyticsData();
  }

  async getAnalyticsData() {

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'))
      .set('currency_lang', this.globals.currency_lang);


    this.chartCheck = false;
    this.http.post(this.globals.analytics_path + 'analytics/stock_abc_products', params, {})
      .subscribe(async response => {
        //list
        this.rows_a = response['a_list'];
        this.temp_a = response['a_list'];
        this.rows_b = response['b_list'];
        this.temp_b = response['b_list'];
        this.rows_c = response['c_list'];
        this.temp_c = response['c_list'];

        this.chartCheck = true;//boolean check
      });
  }

  updateFilterA(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp_a.filter(function (d) {
      return d.name.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows_a = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  updateFilterB(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp_b.filter(function (d) {
      return d.name.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows_b = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  updateFilterC(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp_c.filter(function (d) {
      return d.name.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows_c = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  export() {
    const combinedData = [
      ...this.rows_a.map(item => ({ ...item, category: 'A' })),
      ...this.rows_b.map(item => ({ ...item, category: 'B' })),
      ...this.rows_c.map(item => ({ ...item, category: 'C' }))
    ]
    const params = new HttpParams()
      .set('data', JSON.stringify(combinedData))
      .set('date1', moment(this.advancedAnalyticsServices.date1).format('DD/MM/YYYY HH:mm:ss'))
      .set('date2', moment(this.advancedAnalyticsServices.date2).format('DD/MM/YYYY HH:mm:ss'))
      .set('extras', JSON.stringify({}));
    this.http.post(this.globals.analytics_path + 'export/analytics', params, {})
      .subscribe(async res => {
        if (this.globals.so_mobile) {
          window.location.assign(res['task']);
        } else {
          window.open(res['task'], '_blank');
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/pages/analytics/reports/stock-abc/stock-abc.ts